import { useRef } from 'react';
import { createPortal } from 'react-dom';
import type { ShippingEvent } from '../lib/events';
import { formatEventTime } from '../lib/time';
import { useBesideCursor } from '../useBesideCursor';
import styles from './EventCard.module.css';

/** Props for {@link EventCard}. */
export interface EventCardProps {
  event: ShippingEvent;
  clientX: number;
  clientY: number;
  timeZone: string;
}

const MISSING = '—';

/** The hovered shipping event: its title, weekday and time on the right, and its location in capitals beneath. */
const EventCard = ({ event, clientX, clientY, timeZone }: EventCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useBesideCursor(ref, clientX, clientY);

  return createPortal(
    <div ref={ref} role='tooltip' className={styles.card}>
      <div className={styles.top}>
        <span className={styles.title}>{event.action || MISSING}</span>
        <span className={styles.time}>
          {formatEventTime(event.at, timeZone)}
        </span>
      </div>
      <div className={styles.location}>{event.location}</div>
    </div>,
    document.body
  );
};

export default EventCard;
